import React from 'react';
import DataMetrics from '../dataMetrics';
import { FiStar } from 'react-icons/fi';

const Reviews = ({ reviews }) => {
  return (
    <DataMetrics>
      <ul className="full-width">
        {reviews.map((value, index) => {
          return (
            <li key={index}>
              <span className="info">
                <span className="rating">
                  <FiStar color={ value.rating >= 4 ? '#0cce6b' : value.rating >2 ? '#ffa400' : '#ff4e42'}/>{value.rating}
                </span>
                <span className="time">
                  {value.relative_time_description}
                </span>
              </span>
              <span className="review">
                {value.text}
              </span>
            </li>
          )
        })}
      </ul>
    </DataMetrics>
  )
}
export default Reviews;